export const NON_COMPLIANT_APPOINTMENTS_ERROR_CODE = 'CFE000057';
export const NON_COMPLIANT_APPOINTMENTS_ERROR_KEY = 'NON_COMPLIANT_APPOINTMENTS';

export type NonCompliantAppointmentFeedback = {
  code: string;
  type: 'error' | 'warning';
};

export type NonCompliantAppointmentApprovalError = {
  errorCode: typeof NON_COMPLIANT_APPOINTMENTS_ERROR_CODE;
  feedback: NonCompliantAppointmentFeedback[];
  activityIds?: number[];
};

function isFeedbackItem(value: unknown): value is NonCompliantAppointmentFeedback {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const item = value as Record<string, unknown>;
  return (
    typeof item.code === 'string' &&
    (item.type === 'error' || item.type === 'warning')
  );
}

export function parseNonCompliantAppointmentApprovalError(
  error: unknown
): NonCompliantAppointmentApprovalError | null {
  if (!error || typeof error !== 'object') {
    return null;
  }

  const candidate = error as Record<string, unknown>;
  const matchesCode = candidate.errorCode === NON_COMPLIANT_APPOINTMENTS_ERROR_CODE;
  const matchesKey = candidate.message === NON_COMPLIANT_APPOINTMENTS_ERROR_KEY;
  if (!matchesCode && !matchesKey) {
    return null;
  }

  const rawFeedback = Array.isArray(candidate.feedback) ? candidate.feedback : [];
  const feedback = rawFeedback.filter(isFeedbackItem);

  return {
    errorCode: NON_COMPLIANT_APPOINTMENTS_ERROR_CODE,
    feedback,
    activityIds: Array.isArray(candidate.activityIds)
      ? candidate.activityIds.filter((id): id is number => typeof id === 'number')
      : undefined,
  };
}

export function hasErrorFeedback(
  feedback: Array<{ type?: string }> | undefined
): boolean {
  return (feedback ?? []).some((item) => item.type === 'error');
}
